import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Stats from "@/components/Stats";
import Work from "@/components/Work";
import Services from "@/components/Services";
import Solutions from "@/components/Solutions";
import BeforeAfter from "@/components/BeforeAfter";
import Partnership from "@/components/Partnership";
import Process from "@/components/Process";
import Engagement from "@/components/Engagement";
import Faq from "@/components/Faq";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

export default function App() {
    return (
        <div className="min-h-screen bg-[#FDF7F2] font-body text-[#1C1917] antialiased">
            <Navbar />
            <main>
                <Hero />
                <Marquee />
                <Stats />
                <Work />
                <Services />
                <Solutions />
                <BeforeAfter />
                <Partnership />
                <Process />
                <Engagement />
                <Faq />
                <Contact />
            </main>
            <Footer />
            <Toaster position="top-center" richColors />
        </div>
    );
}
